import { useMutation } from 'react-query';

import {
  RenderAgencyQuickReplyDto,
  RenderedAgencyQuickReplyDto,
} from '@bandido/shared/dtos';
import { client } from '@frontend/features/common/services';

type RenderQuickReplyPayload = {
  quickReplyId: number;
  data: RenderAgencyQuickReplyDto;
};

export const useRenderQuickReply = (agencyId?: number) =>
  useMutation(
    async ({
      quickReplyId,
      data,
    }: RenderQuickReplyPayload): Promise<RenderedAgencyQuickReplyDto> => {
      if (!agencyId) {
        return Promise.reject(new Error('Agency ID is required'));
      }

      const response = await client.post(
        `/whatsapp/quick-replies/${agencyId}/${quickReplyId}/render`,
        data,
      );

      return response.data;
    },
  );
